import React from "react";
import { DataTable } from "primereact/datatable";

export const TowerRowTreeview = (props) => (
  <DataTable selectionMode="single" value={props.records} className="lxTableAuditDetail" emptyMessage="Não foram encontrados registros">
    {props.columns}
  </DataTable>
);
